"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Sliding_Marker_1 = __importDefault(require("./Sliding_Marker"));
const react_leaflet_1 = require("react-leaflet");
class DriftMarker extends react_leaflet_1.MapLayer {
    createLeafletElement(props) {
        const el = new Sliding_Marker_1.default(props.position, this.getOptions(props));
        this.contextValue = Object.assign({}, props.leaflet, { popupContainer: el });
        return el;
    }
    updateLeafletElement(fromProps, toProps) {
        if (toProps.position !== fromProps.position && typeof toProps.duration == 'number') {
            this.leafletElement.slideTo(toProps.position, {
                duration: toProps.duration,
                keepAtCenter: toProps.keepAtCenter
            });
        }
        if (toProps.icon !== fromProps.icon && toProps.icon) {
            this.leafletElement.setIcon(toProps.icon);
        }
        if (toProps.zIndexOffset !== fromProps.zIndexOffset && toProps.zIndexOffset !== undefined) {
            this.leafletElement.setZIndexOffset(toProps.zIndexOffset);
        }
        if (toProps.opacity !== fromProps.opacity && toProps.opacity !== undefined) {
            this.leafletElement.setOpacity(toProps.opacity);
        }
        if (toProps.draggable !== fromProps.draggable && this.leafletElement.dragging !== undefined) {
            if (toProps.draggable === true) {
                this.leafletElement.dragging.enable();
            }
            else {
                this.leafletElement.dragging.disable();
            }
        }
    }
    render() {
        const { children } = this.props;
        return children == null || this.contextValue == null ? null : (react_1.default.createElement(react_leaflet_1.LeafletProvider, { value: this.contextValue }, children));
    }
}
exports.default = react_leaflet_1.withLeaflet(DriftMarker);
//# sourceMappingURL=SlidingMarker.js.map